import { Checkbox, FormLayout, Select, Stack, TextField, Button, Text } from "@shopify/polaris";
import { ViewMajor } from "@shopify/polaris-icons";
import { useAppDispatch } from "../../../../../../../../hooks/redux.js";
import { openModal } from "../../../../../../../../store/features/modal.js";
import {
  REAL_TIME,
  TIME_12_HR,
  TIME_1_DAY,
  TIME_30_DAY,
  TIME_7_DAY
} from "../../../../../../../../../constants/timeInMs.js";
import { OPEN_MODAL_NOTIFICATION_PREVIEW } from "../../../../../../../../constants/modalTypes.js";

const notifyOptions = [
  { label: "Instantly when the action happens", value: REAL_TIME },
  { label: "Summary every 12 hours", value: TIME_12_HR },
  { label: "Summary every day", value: TIME_1_DAY },
  { label: "Summary every week", value: TIME_7_DAY },
  { label: "Summary every month", value: TIME_30_DAY }
];

const checkBoxLabels = {
  outStockNotify: "Notify me when product is out of stock",
  lowStockNotify: "Notify me when product is low on stock",
  backStockNotify: "Notify me when product is back in stock",
  actionNotify: "Notify me when product is out of stock or low on stock",
  attributesActions: "Notify me when an action happens"
};

const NotifySection = ({ input, meta }) => {
  const dispatch = useAppDispatch();
  const { name } = input;
  const { touched, error } = meta;

  const handleChangeIsActive = () => {
    input.onChange({ ...input.value, isActive: !input.value.isActive });
  };

  const handleChangeEmail = (value) => {
    input.onChange({ ...input.value, email: value });
  };

  const handleFrequencyChange = (value) => {
    input.onChange({ ...input.value, frequency: value });
  };

  return (
    <Stack vertical>
      <Checkbox
        label={checkBoxLabels[name]}
        checked={input.value.isActive}
        onChange={handleChangeIsActive}
      />
      <div style={{ paddingLeft: "1.75rem" }}>
        <FormLayout>
          <Stack spacing="extraTight" vertical>
            <Text as="span" variant="bodyMd">How often would you like to get notifications?</Text>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <Select
                  label=""
                  options={notifyOptions}
                  onChange={handleFrequencyChange}
                  value={input.value.frequency}
                  disabled={!input.value.isActive}
                />
              </div>
              <div style={{ margin: "0 10px", display: "flex", justifyContent: "center" }}>
                <Button
                  disabled={!input.value.isActive}
                  icon={ViewMajor}
                  onClick={() => {
                    dispatch(openModal({
                      modalType: OPEN_MODAL_NOTIFICATION_PREVIEW,
                      modalData: {
                        frequency: input?.value?.frequency?.toString(),
                      }
                    }));
                  }}
                  plain
                />
              </div>
            </div>
          </Stack>
          <TextField
            label="Notification email"
            value={input.value.email}
            onChange={handleChangeEmail}
            autoComplete="off"
            placeholder="Email"
            disabled={!input.value.isActive}
            error={touched && error}
            onBlur={() => input.onBlur()}
          />
        </FormLayout>
      </div>
    </Stack>
  );
};

export default NotifySection;
